import axios from 'axios';

export function getApiHealth() {
  return axios.get('/');
}

export function getHealthStatus() {
  return axios.get('/health-status');
}
